module.exports = __webpack_public_path__ + "static/media/sub_saf_dat.d0d84054.png";